var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 90,
    viewBox: "0 0 185 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.032 82.2125C172.787 84.882 173.942 88.0552 176.612 89.3001C179.281 90.5449 182.454 89.3899 183.699 86.7204C184.944 84.0508 183.789 80.8776 181.12 79.6328C178.45 78.388 175.277 79.5429 174.032 82.2125ZM0.577382 2.43268L178.443 85.3727L179.288 83.5601L1.42262 0.620059L0.577382 2.43268Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLine2);
export default __webpack_public_path__ + "static/media/bottomLine2.9881eec28fbea485f500ab1991d796b0.svg";
export { ForwardRef as ReactComponent };